import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";
import Login from "./components/Login/Login";
import Home from "./components/Dashboard/Homepage";
import Register from "./components/Register/Register";

import Navbar from "./components/Navbar/Sidebar";

import CreateInventory from "./components/Inventory/createInventory";
import EditInventory from "./components/Inventory/EditInventory";
import ShowInventory from "./components/Inventory/viewInventory";

import CreateStock from "./components/Stock/createStock";
import EditStock from "./components/Stock/EditStock";
import ShowStock from "./components/Stock/viewStock";

import CreateInvoice from "./components/Invoice/createInvoice";
import EditInvoice from "./components/Invoice/EditInvoice";
import ShowInvoice from "./components/Invoice/viewInvoice";
import MainInvoice from "./components/Invoice/MainInvoice";

import CreateCustomer from "./components/Customer/createCustomer";
import EditCustomer from "./components/Customer/EditCustomer";
import ShowCustomer from "./components/Customer/viewCustomer";

function App() {
  const [user, setLoginUser] = useState();

  useEffect(() => {
    setLoginUser(JSON.parse(localStorage.getItem("MyUserss")));
  }, []);

  const updateUser = (user) => {
    localStorage.setItem("MyUserss", JSON.stringify(user));
    setLoginUser(user);
  };

  return (
    <div className="App">
      <Router>
        {user && user._id ? <Navbar updateUser={updateUser} /> : <div />}
        <Switch>
          <Route exact path="/">
            {user && user._id ? <Home /> : <Login updateUser={updateUser} />}
          </Route>

          <Route path="/register">
            <Register />
          </Route>
          {user && user._id ? (
            <Route>
              <Route path="/add-inventory" exact component={CreateInventory} />
              <Route
                path="/inventory/edit/:id"
                exact
                component={EditInventory}
              />
              <Route path="/view-inventory" exact component={ShowInventory} />
              <Route path="/add-stock" exact component={CreateStock} />
              <Route path="/stock/edit/:id" exact component={EditStock} />
              <Route path="/view-stock" exact component={ShowStock} />

              <Route path="/add-invoice" exact component={CreateInvoice} />
              <Route path="/invoice/edit/:id" exact component={EditInvoice} />
              <Route path="/view-invoice" exact component={ShowInvoice} />
              <Route path="/print-invoice/:id" exact component={MainInvoice} />

              <Route path="/add-customer" exact component={CreateCustomer} />
              <Route path="/customer/edit/:id" exact component={EditCustomer} />
              <Route path="/view-customer" exact component={ShowCustomer} />
            </Route>
          ) : (
            <Login updateUser={updateUser} />
          )}
        </Switch>
      </Router>
    </div>
  );
}

export default App;
